import { render, staticRenderFns } from "./ButtonTootip.vue?vue&type=template&id=c953d8d8&scoped=true&"
import script from "./ButtonTootip.vue?vue&type=script&lang=js&"
export * from "./ButtonTootip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c953d8d8",
  null
  
)

export default component.exports